import React from "react";
import { Card } from "@/components/ui/card";
import { User as UserIcon } from "lucide-react";
import TreeNodeCard from "@/components/TreeNodeCard";

// Recursive renderer split into its own module (workaround for Babel's
// self-reference recursion limit inside a single file).
function TreeBranch({ node, depth, isRoot }) {
  const [open, setOpen] = React.useState(depth < 2 || isRoot);
  const children = node.children || [];
  const hasChildren = children.length > 0;
  return (
    <div className="relative" data-testid={`tree-node-${node.id}`}>
      {depth > 0 ? (
        <span className="absolute -left-4 top-6 w-4 h-px bg-border" aria-hidden />
      ) : null}
      <TreeNodeCard
        node={node}
        depth={depth}
        isRoot={isRoot}
        open={open}
        onToggle={() => setOpen((o) => !o)}
      />
      {hasChildren && open ? (
        <div className="relative pl-6 mt-1 ml-2 space-y-2 border-l-2 border-dashed border-border">
          {children.map((child) =>
            React.createElement(TreeBranch, {
              key: child.id,
              node: child,
              depth: depth + 1,
              isRoot: false,
            })
          )}
        </div>
      ) : null}
    </div>
  );
}

export default function GenealogyTree({ roots, emptyLabel }) {
  if (!roots || roots.length === 0) {
    return (
      <Card className="p-8 text-center text-sm text-muted-foreground">
        <UserIcon className="w-6 h-6 mx-auto mb-2 opacity-50" />
        {emptyLabel || "No hierarchy yet."}
      </Card>
    );
  }
  return (
    <div className="space-y-4" data-testid="genealogy-tree">
      {roots.map((r) => (
        <TreeBranch key={r.id} node={r} depth={0} isRoot={true} />
      ))}
    </div>
  );
}
